<div class="h-100 d-flex flex-column justify-content-between">
    <h2 class="my-3" [innerHTML]="'common-error-not-found' | translate"></h2>
    <button class="btn btn-primary w-100 mt-5" routerLink="/" [innerHTML]="'common-redirect-to-home' | translate"></button>
</div>